export const formatPageList = (inputArr = []) => {
    const arr = JSON.parse(JSON.stringify(inputArr));
    arr.map((ac) => {
        ac.page_name = ac.page_name.toLowerCase();
    });

    const active = arr.filter((page) => page.status === "Active").sort((a, b) => (a.page_name > b.page_name ? 1 : b.page_name > a.page_name ? -1 : 0));
    const inactive = arr.filter((page) => page.status === "Inactive").sort((a, b) => (a.page_name > b.page_name ? 1 : b.page_name > a.page_name ? -1 : 0));
    const expired = arr.filter((page) => page.status === "Expired").sort((a, b) => (a.page_name > b.page_name ? 1 : b.page_name > a.page_name ? -1 : 0));
    const finalArr = [...active, ...inactive, ...expired];

    let sortedArray = [];

    finalArr.map((ac) => {
        const element = inputArr.find((page) => page.page_id === ac.page_id);
        sortedArray.push(element);
    });

    return sortedArray.map((page) => {
        return {
            label: `${page.page_name} (${page.status})`,
            value: page.page_id,
            status: page.status,
            profile_pic: page.page_profile_pic,
            updated_date: page.updated_at,
            handler: page.page_username,
        };
    });
};
